import { createContext, useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { login } from 'api'
import { useNavigate } from 'react-router-dom'

interface Context {
  isAuthorized: boolean
  setIsAuthorized: (isAuthorized: boolean) => void
  error: boolean
  setError: (error: boolean) => void
  handleLogin: (username: string, password: string) => void
  currentUser: any
  setCurrentUser: (user: any) => void
  handleLogout: () => void
}
export const AuthContext = createContext<Context>({
  isAuthorized: false,
  setIsAuthorized: () => {},
  error: false,
  setError: () => {},
  handleLogin: () => {},
  currentUser: {},
  setCurrentUser: () => {},
  handleLogout: () => {}
})

interface Props {
  children: any
}

const AuthContextProvider = ({ children }: Props) => {
  const navigate = useNavigate()
  const [isAuthorized, setIsAuthorized] = useState(
    Cookies.get('userCookie') && localStorage.getItem('user') ? true : false
  )
  const [currentUser, setCurrentUser] = useState<any>(
    JSON.parse(localStorage.getItem('user')!)
  )
  const [error, setError] = useState(false)
  const handleLogin = async (username: string, password: string) => {
    try {
      const result: any = await login(username, password)
      if (result.data.success) {
        localStorage.setItem('user', JSON.stringify(result.data.user))
        setIsAuthorized(true)
        setCurrentUser(result.data.user)
        navigate('/')
      } else {
        setError(true)
      }
    } catch (err) {
      setError(true)
      console.error(err)
    }
  }
  const handleLogout = () => {
    Cookies.remove('userCookie', {
      domain: process.env.REACT_APP_AUTH_COOKIE_DOMAIN
    })
    setCurrentUser(null)
    setIsAuthorized(false)
    navigate('/login')
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthorized,
        setIsAuthorized,
        error,
        setError,
        handleLogin,
        currentUser,
        setCurrentUser,
        handleLogout
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContextProvider
